module.exports = __webpack_public_path__ + "media/images/icons/country_flags/es-ct-ae2d1ab93385b37fd124bbad96005ac8.svg";